export const stateName = 'next-env' as const
